export default {"src":"/_next/static/image/public/images/ic_location_white_bg.a380b1c07ab65daff76fa4280ada552a.svg","height":40,"width":40};